import { injectable, inject } from 'inversify';
import IDateHandler from './i-date-handler';
const DateAndTime = require('date-and-time');
const ru = require('date-and-time/locale/ru');
 // Switch to Spanish

@injectable()
export default class DateHandlerService implements IDateHandler {

    _date!: Date;

    Parse(date: string | Date, format?: string) {
        if (date instanceof Date) {
            this._date = date;
        }
        else if (format !== undefined) {
            this._date = DateAndTime.parse(date, format);
        }
        return this;
    }

    ParseToDate(date: string | Date, format?: string) {
        if (date instanceof Date) {
            this._date = date;
        }
        else if (format !== undefined) {
            this._date = DateAndTime.parse(date, format);
        }
        return this._date;
    }

    Locale(locale: string): void {
        DateAndTime.locale(ru);
    }

    public Format(format?: string): string {
        return DateAndTime.format(this._date, format);
    }

    public Add(type: string, amount: number): this {
        switch (type) {
            case "years": {
                this._date = DateAndTime.addYears(this._date, amount);
                break;
            }
            case "months": {
                this._date = DateAndTime.addMonths(this._date, amount);
                break;
            }
            case "days": {
                this._date = DateAndTime.addDays(this._date, amount);
                break;
            }
            case "hours": {
                this._date = DateAndTime.addHours(this._date, amount);
                break;
            }
            case "minutes": {
                this._date = DateAndTime.addMinutes(this._date, amount);
                break;
            }
            case "seconds": {
                this._date = DateAndTime.addSeconds(this._date, amount);
                break;
            }
            default: {
                this._date = DateAndTime.addMilliseconds(this._date, amount);
                break;
            }
        }
        return this;
    }
    public Subtract(type: string, amount: number): this {
        return this.Add(type, amount * -1);
    }

}